export default __webpack_public_path__ + "static/media/RATE_MDS.09312aa5.png";